import React from 'react';

function ResumePaper({ children, isCompact = false }) {
    // Use conditional classes for compact languages (FR, PT)
    // Tailwind requires full class names, not dynamic strings
    const paddingClass = isCompact ? 'p-[8mm_15mm]' : 'p-[10mm_15mm]';
    const contentSpacing = isCompact ? 'space-y-2' : 'space-y-3';
    
    return (
        <div className="bg-gray-200 print:bg-transparent flex print:block justify-center items-center print:p-0 w-full min-w-[8.5in]">
            <div className={`m-[2.5rem] print:m-0 ${contentSpacing} bg-white ${paddingClass} rounded shadow-lg print:shadow-none min-w-[8.5in] min-h-[11in] max-w-[8.5in] max-h-[11in] print:h-auto print:min-h-0 print:max-h-none print:break-inside-avoid overflow-hidden`}>
                {children}
            </div>
        </div>
    );
}


export default ResumePaper;
